import axios from 'axios';
import {BASE_URL} from '../ApiService/ApiConfig.js'
const URL_BASE_MONITOREO = BASE_URL;

const obtenerConfig = () => {
    const token = localStorage.getItem('jwt').replaceAll('"', '');

    return {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            Authorization: 'Bearer ' + token
        }
    };
};

export const obtieneGeofencesTraccar = async (ubicaCode) => {
    try {
        //console.log('JZJ00:', ubicaCode);
        const response = await axios.get(`${URL_BASE_MONITOREO}/infoGeofences/ubicacion/${ubicaCode}`, obtenerConfig());
        //console.log('JZJ01:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error: ', error.message);
        throw new Error('Error al recuperar los datos');
    }
};

export const obtieneUbicaciones = async () => {
    try {
        //console.log('KN00:');
        //const response = await axios.get(`${URL_BASE_MONITOREO}/ubicacion`, obtenerConfig());
        //console.log('KN01:', response.data);
        //return response.data;
        // Datos de ejemplo en una variable
        const datosDeEjemplo = [
            { codigo: "PSCOM-EC1727", nombre: "EMPACADORA JOSE MIGUEL 1" },
            { codigo: "PSCOM-EC1260", nombre: "EMPACADORA DARWIN ANDRES 2" },
            { codigo: "PSCOM-EC1249", nombre: "EMPACADORA SANTA RITA" },
            { codigo: "PSASO-EC2415", nombre: "EMPACADORA CAMEONCE" },
            { codigo: "PSADEP-EC1443", nombre: "EMPACADORA FENAPROPE" },
            { codigo: "PSADEP-EC360", nombre: "EMPACADORA AMANDA RENATA" },
            { codigo: "PSADEP-EC100", nombre: "PUERTO SECO ADELANTADO EN PLANTA EMPACADORA NUEVA ESPERANZA" },
            { codigo: "PS02", nombre: "PUERTO SECO LOS RIOS" },
            { codigo: "PS01", nombre: "PUERTO SECO GUAYAS" },
        ];
        return Promise.resolve(datosDeEjemplo);
    } catch (error) {
        console.error('Error: ', error.message);
        throw new Error('Error al recuperar los datos');
    }
};


export const obtieneFechaUltProceso = async () => {
    try {
        const response = await axios.get(`${URL_BASE_MONITOREO}/infoGeofences/ultimoProceso`, obtenerConfig());
        //console.log('XXj01:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error: ', error.message);
        throw new Error('Error al recuperar los datos');
    }
}